// Países y nombres locales de las industrias. ESM puro: compartido por el build y las vistas.
export const PAISES = {
  chile: 'Chile',
  argentina: 'Argentina',
  brasil: 'Brasil',
  colombia: 'Colombia',
  ecuador: 'Ecuador',
  mexico: 'México',
  peru: 'Perú',
  uruguay: 'Uruguay',
};

// SVG locales de flag-icons 7.3.2 (MIT): https://github.com/lipis/flag-icons
// Licencia conservada en public/assets/rankings/countries/LICENSE.txt.
export const COUNTRY_FLAGS = {
  chile: 'cl', argentina: 'ar', brasil: 'br', colombia: 'co',
  ecuador: 'ec', mexico: 'mx', peru: 'pe', uruguay: 'uy',
};

// Solo cambia la etiqueta pública; los informes de medición conservan su nombre y su slug originales.
export const LOCAL_NICHE_LABELS = {
  // Chile separa IP y CFT por su tipo legal (spec 006 de brand-presence-agent): se nombran como en Chile.
  chile: { 'institutos-profesionales': 'Institutos profesionales', preuniversitarios: 'Preuniversitarios' },
  argentina: { 'institutos-profesionales': 'Institutos superiores técnicos y profesionales', 'preuniversitarios': 'Preparación de ingreso universitario', 'isapres-seguros-de-salud': 'Medicina prepaga', 'institutos-tecnicos-cft': 'Institutos terciarios' },
  brasil: { 'institutos-profesionales': 'Formación tecnológica superior', 'preuniversitarios': 'Cursinhos pré-vestibular y ENEM', 'afp-pensiones-prevision': 'Previsión privada', 'isapres-seguros-de-salud': 'Planes de salud', 'institutos-tecnicos-cft': 'Educación técnica' },
  colombia: { 'institutos-profesionales': 'Formación técnica profesional y tecnológica superior', 'afp-pensiones-prevision': 'Fondos de pensiones', 'isapres-seguros-de-salud': 'EPS y medicina prepagada', 'institutos-tecnicos-cft': 'Institutos técnicos y tecnológicos' },
  ecuador: { 'isapres-seguros-de-salud': 'Salud y medicina prepagada', 'institutos-tecnicos-cft': 'Institutos técnicos y tecnológicos' },
  mexico: { 'institutos-profesionales': 'Escuelas de formación tecnológica y profesional superior', 'afp-pensiones-prevision': 'Afores', 'isapres-seguros-de-salud': 'Seguros de gastos médicos', 'institutos-tecnicos-cft': 'Institutos técnicos' },
  peru: { 'isapres-seguros-de-salud': 'EPS y seguros de salud', 'institutos-tecnicos-cft': 'Institutos técnicos' },
  uruguay: { 'afp-pensiones-prevision': 'AFAP', 'isapres-seguros-de-salud': 'Mutualistas y seguros de salud', 'institutos-tecnicos-cft': 'Educación técnica y terciaria' },
};
